import { useSelector } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';

import AddRegularCreditCard from './addModal/AddRegularCreditCard';

const AddModal = (props) => {
  const { onCloseModal, cancelFunction, onAddCreditCard } = props;
  const settings = useSelector((state) => state.setting).data;

  if (!settings) {
    return (
      <Modal title="Add Credit Card" onCloseModal={onCloseModal}>
        &nbsp;
      </Modal>
    );
  }

  return (
    <AddRegularCreditCard
      onCloseModal={onCloseModal}
      cancelFunction={cancelFunction}
      onAddCreditCard={onAddCreditCard}
    />
  );
};

export default AddModal;
